<template>
  <nav v-if="items.length" class="breadcrumb is-small product-breadcrumbs" aria-label="breadcrumbs">
    <ul>
      <li>
        <nuxt-link :to="localePath('index')">
          Home
        </nuxt-link>
      </li>
      <li v-for="(item, index) in items" :key="index">
        <!-- Ostatni element to biezaca strona - bez linku, jak na blogu -->
        <span v-if="index === items.length - 1" class="is-current" aria-current="page">
          {{ item.name }}
        </span>
        <a v-else :href="item.link">
          {{ item.name }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    items () {
      return (this.breadcrumbs || []).filter(x => x && x.name && x.link)
    }
  }
}
</script>

<style lang="scss" scoped>
.product-breadcrumbs {
  margin-bottom: 8px;
  ul {
    margin: 0;
  }

  li + li {
    margin-top: 0;
  }

  a {
    color: #000000;

    &:hover {
      text-decoration: underline;
    }
  }

  .is-current {
    padding: 0 0.75em;
    color: #000000;
  }
}
</style>
